import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import {
  ShowViewFilter,
  TouchModeToggle
} from '@features/calibration/components/shared';
import { SaveStatusIndicator } from '@features/calibration/hooks/useCalibrationRuntime';
import { useShowView, useCalibrationUIStore } from '@stores/calibrationUIStore';
import type { RunnerSaveStatus } from '../types';

type RunnerToolbarProps = {
  readOnly?: boolean;
  robotStatus?: React.ReactNode;
  saveStatus?: RunnerSaveStatus;
};

const RunnerToolbar: React.FC<RunnerToolbarProps> = ({
  readOnly = false,
  robotStatus,
  saveStatus
}) => {
  const { t } = useTranslation('calibration');
  const showView = useShowView();
  const setShowView = useCalibrationUIStore(state => state.setShowView);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 2,
        mb: 2
      }}
    >
      {!readOnly && (
        <>
          <TouchModeToggle />
          {saveStatus ? (
            <SaveStatusIndicator
              isSaving={saveStatus.isSaving}
              lastSaved={saveStatus.lastSaved}
              saveError={saveStatus.saveError}
              syncStatus={saveStatus.syncStatus}
            />
          ) : (
            <Chip
              size="small"
              variant="outlined"
              icon={<CheckIcon color="success" />}
              label={t('runner.autoSaveEnabled')}
            />
          )}
          <Typography variant="caption" color="text.secondary">
            {t('testGrid.controls.touchModeHint')}
          </Typography>
        </>
      )}
      <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 2 }}>
        <ShowViewFilter showView={showView} onShowViewChange={setShowView} />
        {robotStatus}
      </Box>
    </Box>
  );
};

export default RunnerToolbar;
